import React from "react";
import EnergyCalculator from "../components/EnergyCalculator";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../context/I18nContext";

export default function EnergyPage() {
  const { t } = useLang();
  return (
    <div className="page-shell" data-testid="energy-page">
      <section className="site-container page-hero">
        <div className="eyebrow mb-6">{t("energy.eyebrow")}</div>
        <h1 className="page-title">
          {t("energy.h1.1")} <span className="italic-accent">{t("energy.h1.italic")}</span> {t("energy.h1.2")}
        </h1>
        <p className="copy-lead mt-8 text-base md:text-lg max-w-xl">
          {t("energy.intro")}
        </p>
      </section>

      <section className="site-container section-block">
        <EnergyCalculator/>
      </section>

      <section className="site-container section-block">
        <div className="cta-panel text-center">
          <div className="eyebrow mb-5">{t("energy.nextStep")}</div>
          <h2 className="section-title max-w-2xl mx-auto">
            {t("energy.h2.1")}<br/><span className="italic-accent">{t("energy.h2.italic")}</span> {t("energy.h2.2")}
          </h2>
          <div className="mt-12 flex flex-wrap justify-center gap-4">
            <Link to="/kontakt" className="btn-primary" data-testid="energy-cta-contact">
              {t("energy.ctaConsult")} <ArrowRight size={14}/>
            </Link>
            <Link to="/shop?cat=vollsystem-wp" className="btn-ghost" data-testid="energy-cta-shop">
              {t("energy.ctaShop")}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
